<template>
  <div class="category-view-table-section">
    <div class="table-header">
      <div class="columns col_1">Course Number</div>
      <div class="columns col_2">Course Name</div>
      <div class="columns col_3"># of {{creditLabel}}s</div>
      <div class="columns col_1">Date of Completion</div>
      <div class="columns col_3">Grade</div>
      <div class="columns col_3">Status</div>
    </div>
    <div class="table-content">
      <div class="table-row" v-for="course in categories" v-if="course.entityType !== 'courseOptions'">
        <div class="columns col_1" :title="courseCode(course.title)"><span class="label">{{courseCode(course.title)}}</span></div>
        <div class="columns col_2" :title="course.title"><span class=""><v-clamp class="title_new" autoresize :max-lines="2">{{ course.title }}</v-clamp></span></div>
        <div class="columns col_3 text-center" :title="course.creditsEarned"><span class="label">{{course.creditsEarned}}</span></div>
        <div class="columns col_1" :title="course.term"><span class="label">{{course.term}}</span></div>
        <div class="columns col_3 text-center" :title="course.grade"><span class="label">{{course.grade}}</span></div>
        <div class="columns col_3 text-center status">
          <span class="status-bar complete" v-if="course.status === 'COMPLETED'"></span>
          <span class="status-bar in-progress" v-if="course.status === 'INPROGRESS' || course.status === 'GRADE_PENDING' || course.status === 'INCOMPLETE'"></span>
          <span class="status-bar transferred" v-if="course.status === 'TRANSFERRED'"></span>
          <span class="status-bar scheduled" v-if="course.status === 'NOT_STARTED'"></span>
        </div>
      </div>
      <div class="course-status-row usedto-course" v-if="availableCourses.length > 0">The following courses may be used to complete the requirement</div>
      <div class="table-row" v-for="course in availableCourses">
        <div class="columns col_1" :title="course.code"><span class="label">{{course.code}}</span></div>
        <div class="columns col_2" :title="course.title"><span class=""><v-clamp class="title_new" autoresize :max-lines="2">{{ course.title }}</v-clamp></span></div>
        <div class="columns col_3 text-center" :title="course.credits"><span class="label">{{course.credits}}</span></div>
        <div class="columns col_1"><span class="label">N/A</span></div>
        <div class="columns col_3 text-center"><span class="label">N/A</span></div>
        <div class="columns col_3 text-center status">
         <span class="label"> N/A</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import VClamp from 'vue-clamp'

export default {
  name: 'categoryTable',
  props: ['categories'],
  components: {
    VClamp
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCategory'
    ]),
    changeCategory (category) {
      this.loadCategory(category)
    },
    courseCode (title) {
      var titleArray = title.split(' ')
      if (titleArray.length > 1) {
        return titleArray[0] + ' ' + titleArray[1]
      }
      if (titleArray.length > 0) {
        return titleArray[0]
      }
      return ''
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    availableCourses () {
      if (this.categories && this.categories.length > 0) {
        for (var i = 0; i < this.categories.length; i++) {
          let c = this.categories[i]
          if (c.entityType === 'courseOptions') {
            return c.coursesAvailable
          }
        }
      }
    }
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/stream/components/CategoryTable.vue